<template>
    <div class="table-responsive">
        <table class="table table-striped">
            <thead>
            <tr>
                <th>{{'Date'|trans}}</th>
                <th>{{'Points'|trans}}</th>
                <th>{{'Reason'|trans}}</th>
                <th>{{'Comment'|trans}}</th>
            </tr>
            </thead>
            <tbody>
           <template v-for="history in historyPoints">
                   <tr>
                       <td align="center">{{ history.date_exec|formatDate('DD/MM/Y') }}</td>
                       <td align="center">{{ positifFormating(history.nbr_points) }}</td>
                       <td>{{ history.reason|trans }}</td>
                       <td>{{ history.comments }}</td>
                   </tr>
           </template>
            </tbody>
        </table>
    </div>
</template>

<script>

    import moment from "moment-timezone";

	export default {
        props: {
			historyPoints:null
        },
        data() {
            return {

            }
        },
        created(){

        },
        filters:{
			formatDate(value, format) {
				if (value) {
					if (format === undefined) {
						format = 'YYYY-MM-DD HH:mm';
					}
					return moment(String(value)).format(format)
				}
			}
        },
        methods: {
            positifFormating(value){
            	if(value > 0){
            		return '+'+value;
                }
            	return value;
            },
            formatTheDate(date){

            }
        },
        computed: {

        },
    }

</script>

<style scoped>

</style>
